import {
  Globe2,
  Pen,
  ShieldCheck,
  TicketPerforated,
} from "react-bootstrap-icons";

export const UNLOCK_WHITELABEL_FEATURES = [
  {
    icon: Globe2,
    titleKey: "events.modals.unlockWhiteLabel.features.customDomain.title",
    descriptionKey:
      "events.modals.unlockWhiteLabel.features.customDomain.description",
  },
  {
    icon: TicketPerforated,
    titleKey: "events.modals.unlockWhiteLabel.features.brandedUrl.title",
    descriptionKey:
      "events.modals.unlockWhiteLabel.features.brandedUrl.description",
  },
  {
    icon: Pen,
    titleKey: "events.modals.unlockWhiteLabel.features.customizeBranding.title",
    descriptionKey:
      "events.modals.unlockWhiteLabel.features.customizeBranding.description",
  },
  {
    icon: ShieldCheck,
    titleKey: "events.modals.unlockWhiteLabel.features.removeBranding.title",
    descriptionKey:
      "events.modals.unlockWhiteLabel.features.removeBranding.description",
  },
] as const;
